exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gris-couleur[data-v-12876156]{background-color:#e0e0e0}.white-couleur[data-v-12876156]{color:#fff}.v-card__title[data-v-12876156]{font-size:1.2rem;font-weight:400;letter-spacing:normal;line-height:1.5rem}.titreEvent[data-v-12876156]{text-decoration:none}.titreEvent[data-v-12876156]:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12876156","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/events/index-in-progress.vue
// module id = qmPl
// module chunks = 1